import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import React, { Suspense } from "react"
import TopicSavedComparables from "web/app/Deals/ViewDeal/DealComparables/TopicRecords/SavedComparables"

export default class TopicSavedComparablesController extends Controller {
  static values = {
    basePath: String,
    dealId: Number,
    topicName: String,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider subjectType="deal" data={useDeal(this.dealIdValue)}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <DealTLOContextProvider>
                <ErrorBoundary>
                  <TopicSavedComparables
                    baseUrl={this.basePathValue}
                    canRedirectToRootUrl={false}
                    subjectType="asset"
                    topicName={this.topicNameValue}
                  />
                </ErrorBoundary>
              </DealTLOContextProvider>

              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
